export type HazardGenerationSkippedItem = {
  significantHazardId: string
  name: string
  reason: string
}

export type HazardGenerationCompletedResult = {
  hazardsCreated?: number
  totalProcessed?: number
  hazardIds?: string[]
  skipped?: HazardGenerationSkippedItem[]
}

export function parseHazardGenerationSkippedItems(
  result: unknown
): HazardGenerationSkippedItem[] {
  if (result == null || typeof result !== 'object') {
    return []
  }

  const skipped = (result as HazardGenerationCompletedResult).skipped
  if (!Array.isArray(skipped)) {
    return []
  }

  const parsed: HazardGenerationSkippedItem[] = []
  for (const item of skipped) {
    if (item == null || typeof item !== 'object') {
      continue
    }
    const record = item as Record<string, unknown>
    const significantHazardId =
      typeof record.significantHazardId === 'string'
        ? record.significantHazardId.trim()
        : ''
    const name = typeof record.name === 'string' ? record.name.trim() : ''
    const reason = typeof record.reason === 'string' ? record.reason.trim() : ''
    if (name.length === 0 && reason.length === 0) {
      continue
    }
    parsed.push({
      significantHazardId,
      name: name.length > 0 ? name : reason,
      reason,
    })
  }

  return parsed
}
